import React, {useCallback} from 'react'
import {ListLazy} from 'common/components'
import {useHistory} from 'utils'
import {GiftshopPackageActivesResponse} from 'types'
import {GiftshopPackageActiveProps} from './GiftshopPackageActiveProps'
import GiftShopPackageActiveItem from './GiftshopPackageActiveItem'

export default function GiftshopPackageActive({
  data,
}: GiftshopPackageActiveProps) {
  const history = useHistory()

  const handleRenderItem = useCallback(
    (item: GiftshopPackageActivesResponse) => (
      <GiftShopPackageActiveItem
        package={item}
        onClickPackage={() => {
          history.pushQuery({
            path: 'giftshop_package',
            state: {},
            queryObject: {
              tree_id: item.tree_id,
              creator_id: item.creator_member_id,
            },
          })
        }}
      />
    ),
    [history],
  )

  return (
    <ListLazy
      loadData={() => null}
      data={data}
      keyExtractor={(item) => item.package_id}
      renderItem={handleRenderItem}
    />
  )
}
